import React from 'react';

import type { ICity } from '@typings/api/ICity';
import { getCities } from './getCities';

export function useCityList(countryId: number | undefined): ICity[] | undefined {
    const [cities, setCities] = React.useState<ICity[] | undefined>(undefined);

    React.useEffect(() => {
        setCities(undefined);

        if (!countryId) return;

        getCities(countryId).then(setCities);
    }, [countryId]);

    return cities;
}
